import { supabase } from './supabase';

/**
 * Centre de notifications resto (Phase 3). Lecture des notifications d'un tenant +
 * marquage « lu ». Les notifications sont CRÉÉES côté serveur (Edge Functions, service
 * role) : accusé de réception d'une demande, confirmation d'activation, etc.
 * Table `notifications` (cf. sql/56). RÉSILIENT : si la table n'existe pas encore
 * (migration non lancée), on renvoie une liste vide sans casser l'UI.
 */
export interface AppNotification {
  id: string;
  title: string;
  body: string | null;
  kind: string; // info | success | request
  readAt: string | null;
  createdAt: string;
}

/** Charge les 50 dernières notifications d'un resto (plus récentes d'abord). */
export async function loadNotifications(tenantId: string): Promise<AppNotification[]> {
  const { data, error } = await supabase
    .from('notifications')
    .select('id, title, body, kind, read_at, created_at')
    .eq('tenant_id', tenantId)
    .order('created_at', { ascending: false })
    .limit(50);
  if (error || !Array.isArray(data)) {
    if (error) console.warn('[notifications] lecture impossible:', error.message);
    return [];
  }
  return data.map((r) => ({
    id: r.id as string,
    title: r.title as string,
    body: (r.body ?? null) as string | null,
    kind: (r.kind ?? 'info') as string,
    readAt: (r.read_at ?? null) as string | null,
    createdAt: r.created_at as string,
  }));
}

/** Marque une liste de notifications comme lues (best-effort). */
export async function markNotificationsRead(ids: string[]): Promise<void> {
  if (ids.length === 0) return;
  const { error } = await supabase
    .from('notifications')
    .update({ read_at: new Date().toISOString() })
    .in('id', ids)
    .is('read_at', null);
  if (error) console.warn('[notifications] marquage lu impossible:', error.message);
}

/** Nombre de notifications non lues. */
export function unreadCount(list: AppNotification[]): number {
  return list.filter((n) => !n.readAt).length;
}
